export enum AreaNameId {
  ID = 'id',
  NAME_EN = 'nameEn',
  NAME_AR = 'nameAr',
  CITY = "city",
  CITY_ID = "cityId",
  CREATED_AT = 'createdAt',
}


